import { useCallback, useMemo, useState } from 'react';

import { EmailOutlined } from '@mui/icons-material';
import { ActionItemKeys, requestNewVerifyEmail } from '@uplift/api';
import { trackToDoCTA, useActionItem, useL10n } from '@uplift/hooks';
import { UserRole } from '@uplift/types';
import { BaseDashboardActionItem, CheckYourInboxDialog } from '@uplift/ui-v2';


export const useVerifyEmailActionItem = () => {
  const l10n = useL10n();
  const verifyEmailData = useActionItem(ActionItemKeys.CLIENT_EMAIL_VERIFY);
  const [ showRequestDialog, setShowRequestDialog ] = useState(false);

  const handleClick = useCallback(async () => {
    await requestNewVerifyEmail();
    trackToDoCTA({
      toDoType: ActionItemKeys.CLIENT_EMAIL_VERIFY,
      userType: UserRole.patient
    });

    setShowRequestDialog(true);
  }, []);

  const handleClose = useCallback(() => {
    setShowRequestDialog(false);
  }, []);

  const actionItem = useMemo(() => {
    if (verifyEmailData.isLoading) {
      return null;
    }

    if (!verifyEmailData.show) {
      return null;
    }

    return (
      <>
        <BaseDashboardActionItem
          title={l10n.dashboard.actionItems.verifyEmail.title}
          color="warning"
          icon={<EmailOutlined />}
          action={{
            text: l10n.dashboard.actionItems.verifyEmail.actionText,
            handleClick
          }}
        />
        <CheckYourInboxDialog open={showRequestDialog} onClose={handleClose} />
      </>
    );
  }, [ handleClick, handleClose, l10n.dashboard.actionItems.verifyEmail.actionText, l10n.dashboard.actionItems.verifyEmail.title, showRequestDialog, verifyEmailData.isLoading, verifyEmailData.show ]);

  return {
    isLoading: verifyEmailData.isLoading,
    actionItem
  };
};
